// import React from 'react';

// function USDCTestnetFaucet() {
//     return (
//         <div>
//             <iframe
//                 title="USDC Testnet Faucet"
//                 src="https://faucet.circle.com/"
//                 width="100%"
//                 height="700px"
//             ></iframe>
//         </div>
//     );
// }

// export default USDCTestnetFaucet;

import React from 'react';

function USDCTestnetFaucet() {
    const zoomLevel = 0.7; // Adjust this value to zoom out (e.g., 0.5 for 50% of the original size)

    return (
        <div style={{
            width: `${100 / zoomLevel}%`, // Adjust width to compensate for zoom out
            overflow: 'hidden',
            height: '1400px' // Keep height consistent
        }}>
            <div style={{
                transform: `scale(${zoomLevel})`,
                transformOrigin: '0 0',
                width: '100%',
                height: '100%'
            }}>
                <iframe
                    title="USDC Testnet Faucet"
                    src="https://faucet.circle.com/"
                    width="100%"
                    height="1400px"
                    style={{ border: 'none' }}
                ></iframe>
            </div>
        </div>
    );
}

export default USDCTestnetFaucet;
